import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useWindowSize from "../../hooks/useWindowSize";
import { Mixpanel } from "../../config/Mixpanel";
import constants, { courses } from "../../utilities/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { resetQuestions, sendUserSkill } from "../../redux/mcqSlice";
import {
  setLandingPageDetails,
  resetDetails,
  setSource,
  selectLandingPageDetails,
  setUserDetails,
  setReferralId,
  setTestId,
  setUserSkillDetails,
  setShowAnimation,
  referralDetails,
  selectReferralDetails,
} from "../../redux/otherDetailsSlice";
import { resetAnswers } from "../../redux/answersSlice";
import { resetCourseContent } from "../../redux/personaliseCourseSyllabusSlice";
import {
  resetPostPaymentSlice,
  resetPrepaymentDetails,
} from "../../redux/postPaymentSlice";
import {
  fetchInfluencerDetail,
  resetInfluencerData,
} from "../../redux/influencersDataSlice";
import { getUserDetails, setAuthToken } from "../../redux/authenticationSlice";
import { resetCourseSyllabus } from "../../redux/newPostPaymentSlice";
import { resetInitialState } from "../../redux/multiSkillSelectionSlice";
import { resetResults } from "../../redux/searchSlice";
import { resetInitialStateOfPack } from "../../redux/largerComboPackSlice";
import { toast } from "react-toastify";
import { resetTimer } from "../../redux/timerSlice";
import { dayResetTimer } from "../../redux/dayTimerSlice";
import { ClipLoader } from "react-spinners";
import { resetAddOnDetails } from "../../redux/addOnSlice";
import { resetUnPaidUserDetails } from "../../redux/unPaidUserSlice";

const LandingPage = () => {
  const landingPageDetails = useSelector(selectLandingPageDetails);

  const userSkillName = landingPageDetails?.skill_name;
  const utmMedium = landingPageDetails?.utm_medium;
  const utmSource = landingPageDetails?.utm_source;
  const utmCampaign = landingPageDetails?.utm_campaign;

  const [courseName, setCourseName] = useState("");
  const [skillName, setSkillName] = useState("");
  const [randomDigit, setRandomDigit] = useState(0);
  const [navigateToSkill, setNavigateToSkill] = useState(false);
  const [navigateToCourse, setNavigateToCourse] = useState(false);
  const [loading, setLoading] = useState(false);

  const { height, width } = useWindowSize();
  const { skill_name, utm_source } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const utm_source1 = params.get("utm_source");
  const utm_medium = params.get("utm_medium");
  const utm_campaign = params.get("utm_campaign");
  const source = params.get("source");
  const jwt_token = params.get("uuid");
  const referral_id = params.get("referral_id");
  const isReferral = params.get("isReferral")
  const test_id = params.get("test_id");
  const email = params.get("email")
  const skill_name_from_url = params.get("skill_name");

  const scrollRef = useRef(null);
  const referralData= useSelector(selectReferralDetails);
  const [recommendedCourses , setRecommendedCourses] = useState([])
  const [clickedButton1, setClickedButton1] = useState(-1);
  const [clickedButton2 , setClickedButton2] = useState(-1);

  
  const extractSkillRecommendations = (data) => {
    const recommendations = [];
    
    Object.keys(data).forEach(key => {
      if (key.startsWith("SKILL_REC_")) {
        if(data[key].toLowerCase() !== userSkillName.toLowerCase()){
          console.log('data' , data[key] , userSkillName)
          recommendations.push(data[key]);
        }
      }
    });
    
    return recommendations;
  }

  useEffect(() => {
    if(referralData){
      const extractedSkills = extractSkillRecommendations(referralData);
      setRecommendedCourses(extractedSkills);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralData]);

  function capitalizeFirstLetter(sentence = "") {
    const words = sentence.split(" ");
    const capitalizedWords = words.map((word) => {
      if (word.length > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    });
    const capitalizedSentence = capitalizedWords.join(" ");
    return capitalizedSentence;
  }

  const fetchData = useCallback(
    async (token) => {
      try {
        const response = await dispatch(getUserDetails(token));
        const { name, email, phone_number } = response.payload;
        dispatch(setUserDetails({ name, email, phone_number }));
      } catch (error) {
        console.log(error.message);
      }
    },
    [dispatch]
  );


  useEffect(() => {
    
    if(isReferral){
      Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE);
    }
    else{
      Mixpanel.track(constants.Mixpanel.LANDING_PAGE);
    }
    dispatch(setAuthToken(""));
    dispatch(resetInfluencerData());
    dispatch(resetQuestions());
    dispatch(resetDetails());
    dispatch(resetAnswers());
    dispatch(resetCourseContent());
    dispatch(resetPrepaymentDetails());
    dispatch(setShowAnimation(-1));
    dispatch(resetCourseSyllabus());
    dispatch(resetInitialState());
    dispatch(resetResults());
    dispatch(resetInitialStateOfPack());
    dispatch(resetPostPaymentSlice());
    dispatch(resetTimer());
    dispatch(dayResetTimer());
    dispatch(resetAddOnDetails());
    dispatch(resetUnPaidUserDetails());
    if (source === "academy") {
      dispatch(setSource(source));
      dispatch(fetchInfluencerDetail(utm_source1));
    }
    if (jwt_token) {
      dispatch(setAuthToken(jwt_token));
      fetchData(jwt_token);
    }
    if (
      (utm_source && !utm_source?.includes("=")) ||
      (skill_name && !skill_name?.includes("="))
    ) {
      navigate("/error");
    }
    if (referral_id) {
      dispatch(setReferralId(referral_id));
    }
    if (test_id) {
      dispatch(setTestId(test_id));
    }
    let utmSource = utm_source?.split("=");
    let skill = skill_name?.split("=");

    if (!skill_name) {
      dispatch(
        setLandingPageDetails({
          skillName: "",
          utmSource: utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
          courseName: "",
          utmMedium: utm_medium || "",
          utmCampaign: utm_campaign || "",
        })
      );
      setNavigateToCourse(true);
    } else if (courses?.filter((item) => item.course_slug === skill?.[1])[0]) {
      const courseDetail = courses?.filter(
        (item) => item.course_slug === skill?.[1]
      )[0];
      Mixpanel.people.set({
        courseName: courseDetail?.name,
      });
      dispatch(
        setLandingPageDetails({
          skillName: "",
          utmSource: utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
          courseName: courseDetail?.name,
          utmMedium: utm_medium || "",
          utmCampaign: utm_campaign || "",
        })
      );
      setCourseName(courseDetail?.name);
      setNavigateToSkill(true);
    } else {
      Mixpanel.people.set({
        skillName: capitalizeFirstLetter(skill?.[1]),
      });
      dispatch(
        setLandingPageDetails({
          skillName: capitalizeFirstLetter(skill?.[1]),
          utmSource: utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
          courseName: "",
          utmMedium: utm_medium || "",
          utmCampaign: utm_campaign || "",
        })
      );
      setSkillName(capitalizeFirstLetter(skill?.[1]));
    }
    if (skill_name_from_url) {
      setSkillName(skill_name_from_url);
      dispatch(setUserSkillDetails(skill_name_from_url));
      setNavigateToCourse(false);
    }

    const randomDigitGenerate = () => {
      const min = 7000;
      const max = 10000;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    setRandomDigit(randomDigitGenerate);
   
    }, [dispatch, jwt_token, navigate, skill_name, utm_source, utm_source1, source, utm_medium, fetchData, referral_id, test_id, skill_name_from_url, utm_campaign, isReferral])

    
    const handleSubmit = async () => {
        if (loading){
            return
        }
        setLoading(true)
        try {
            if (navigateToCourse && !isReferral) {
                Mixpanel.track(constants.Mixpanel.LANDING_PAGE_BUTTON_CLICKED)
                navigate('/1/course-page')
            }
            else if (navigateToSkill && !isReferral){
                Mixpanel.track(constants.Mixpanel.LANDING_PAGE_BUTTON_CLICKED)
                navigate('/2/skill-page')
                
            }else {
                if(isReferral){
                  Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE_BUTTON_CLICKED);
                }
                else{
                  Mixpanel.track(constants.Mixpanel.LANDING_PAGE_BUTTON_CLICKED)
                }
                await  dispatch(sendUserSkill({ subject_name: userSkillName, utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign })).unwrap()
                navigate('/onboarding')
            }
        } catch (error) {
            toast.error('Oops, that request failed. Please try again!')
        }finally{
            setLoading(false)
        }
        
    }
   

  useEffect(()=>{
    if( isReferral && email){
      dispatch(referralDetails({email : email}))
    }
  },[dispatch, email, isReferral])
  
  useEffect(()=>{
    if(clickedButton1 || clickedButton2){
      setTimeout(()=>{
        setClickedButton1(-1);
        setClickedButton2(-1);
      }, 300)
    }
  } , [clickedButton1 , clickedButton2])

 async function recommendedSkillHandler(item){

      await  dispatch(sendUserSkill({ subject_name: item, utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign })).unwrap()
      dispatch(setLandingPageDetails({
        skillName: item,
        utmSource: utmSource ? utmSource[1] : utm_source1 ? utm_source1 : "",
        courseName: "",
        utmMedium: utm_medium || "",
        utmCampaign: utm_campaign || "",
      }))
      navigate('/onboarding')
  }
  
  return (
    <div className="text-white max-w-[1440px] w-full flex-1 flex flex-col  lg:gap-4 lg:px-6 lg:items-center mx-auto" ref={scrollRef}>
      <div className={`text-white flex-1 flex flex-col lg:flex-row-reverse lg:justify-between lg:gap-4 lg:px-6 lg:items-center mx-auto`}>
        <div className="flex-1 h-full flex flex-col md:justify-center">
          {isReferral ? (
            <h1
              className={`text-[24px] lg:hidden ${
                height <= 740 ? "" : "mt-8 md:mt-0"
              } text-left leading-[34px]`}
            >
              <span className="italic ">{referralData?.FIRST_NAME}, Unlock Your</span>

              <span
                className={`font-bold text-[24px] transition-all duration-300 text-span_color`}
              >
                {" "}
                {userSkillName} Certificate
              </span>
              <span className="italic">
                {" "}
                Recognised By 1100+ Top Companies
              </span>
            </h1>
          ) : (
            <h1
            className={`${width<360 ? 'text-[24px]': 'text-[28px]' } text-center lg:hidden ${
              height <= 740 ? "" : "mt-12 md:mt-0"
            }  leading-[34px]`}
          >
            <span className="italic ">Unlock Your</span>

            <span
              className={`font-bold ${width<360 ? 'text-[24px]': 'text-[28px]' } transition-all duration-300 text-span_color`}
            >
              {" "}
              {userSkillName} Certificate
            </span>
            <span className="italic">
              {" "}
              Recognized By 1100+ Top Company Recruiters To
            </span>
            <span
              className={`font-bold ${width<360 ? 'text-[24px]': 'text-[28px]' } transition-all duration-300 text-span_color`}
            >
              {" "}
              Prove Your Skills
            </span>
          </h1>
          )}
          <div className="">
            <div
              className={`${
                height <= 720 ? "mt-4" : "mt-8"
              } w-full mx-auto md:w-[90%]`}
              style={{
                boxShadow: "0px 0px 12px 0px #FFCC17B2",
              }}
            >
              <img
                src="https://assets.learntube.ai/files/Global/Certificate%20global.png?updatedAt=1744137645047"
                width={'100%'}
                height={'100%'}
                alt=""
                loading="eager"
                className="w-full h-auto object-cover"
              />
            </div>
            {isReferral ? <div className={`bg-secondary_background  rounded-xl mt-4 w-full mx-auto md:w-[90%]`}>
              <img
                src={width < 758 ? `https://assets.learntube.ai/files/certifiedOptimisation/Having%205+.webp?updatedAt=1742193740248` : `https://assets.learntube.ai/files/certifiedOptimisation/Frame%2022951.webp?updatedAt=1742193740010`}
                alt=""
                className="w-full h-auto object-cover"
              />
            </div> : 
            <div className={` mt-4 w-full mx-auto md:w-[90%]`}>
            <img
              src={window.innerWidth < 758 ? 'https://assets.learntube.ai/files/Global/tile%20-%20phone%20(1).png?updatedAt=1744619269178': `https://assets.learntube.ai/files/Global/Tile%20-%20mobile.png?updatedAt=1744184622071`}
              alt=""
              className="w-full h-auto object-cover"
            />
          </div>}
          </div>
        </div>
        <div className={`hidden ${isReferral && "mr-4"} w-full lg:flex lg:flex-col flex-1 items-center`}>
          {isReferral ? (
            <h1
            className={`text-[44px] hidden  lg:block leading-[50px] text-center md:text-start`}
          >
              <span className="italic ">{referralData?.FIRST_NAME}, Unlock Your</span>

              <span
                className={`font-bold  transition-all duration-300 text-span_color`}
              >
                {" "}
                {userSkillName} Certificate
              </span>
              <span className="italic">
                {" "}
                Recognised By 1100+ Top Companies
              </span>
            </h1>
          ) : (

            
            <h1
            className={`text-[44px] hidden  lg:block leading-[50px] text-center md:text-start`}
          >
              <span className="italic ">Unlock Your</span>

              <span
                className={`font-bold  transition-all duration-300 text-span_color`}
              >
                {" "}
                {userSkillName} Certificate
              </span>
              <span className="italic">
                {" "}
                Recognized By 1100+ Top Company Recruiters To
              </span>
              <span
              className={`font-bold transition-all duration-300 text-span_color`}
            >
              {" "}
              Prove Your Skills
            </span>
            </h1>
          )}
          <div className={`flex flex-col items-center mt-10 ${'w-full'}`}>
            <div
              className="bg-[#7FC241] w-full mx-auto cursor-pointer flex text-black justify-center items-center py-3 rounded-xl px-3"
              onClick={() => {
                handleSubmit();
              }}
            >
              {!loading ? (
                <>
                  <p
                    className={`${
                      width <= 320 ? "text-base" : "text-lg"
                    } font-medium`}
                  >
                    Get Certified Now!
                  </p>
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="text-xl ml-4 arrow-move"
                  />
                </>
              ) : (
                <ClipLoader size={25} />
              )}
            </div>
            <p className="text-sm text-white/70 mx-auto mt-2">
              <img src="https://assets.learntube.ai/files/Global/learners/Desktop%201.png?updatedAt=1744440427822" alt="" className="-mt-1.5 mr-1 image-inline" width={50} height={22}/>
              {randomDigit} users got certified this week in <span className="font-medium text-sm text-white ">just 10 mins!</span>
            </p>
          </div>
        </div>

        <div className="fixed  lg:hidden flex flex-col justify-between items-center bottom-0 w-full left-0 z-50 md:left-1/2 md:-translate-x-[50%] pb-1.5 pt-3 px-2 bg-[#26588B] md:w-full">
          <div
            className={`bg-[#7FC241] btn--glow ${isReferral && 'w-[90%]'} sticky bottom-0 text-black flex justify-center items-center  rounded-xl ${
              height <= 720 ? "py-2" : "py-3.5"
            } px-4 w-[75%] cursor-pointer`}
            onClick={() => {
              handleSubmit();
            }}
          >
            {!loading ? (
              <>
                <p
                  className={`${
                    width <= 320 ? "text-base" : "text-lg"
                  } font-medium`}
                >
                  Get Certified Now!
                </p>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-xl ml-4 arrow-move"
                />
              </>
            ) : (
              <ClipLoader size={25} />
            )}
          </div>
          <div className="">
          <p className="text-sm text-white/70 mx-auto mt-2 text-center">
              <img src="https://assets.learntube.ai/files/Global/learners/Mobile%20-1.png?updatedAt=1744440427241" alt="" className="-mt-1.5 mr-1 image-inline" width={50} height={22}/>
              {randomDigit} users got certified this week in <span className="font-medium text-sm text-white ">just 10 mins!</span>
            </p>
          </div>
        </div>
        {isReferral &&  <div className="hidden md:block lg:hidden h-[74px] w-full"></div>}
        {height <= 740 && <div className="h-[200px]"></div>}
      </div>

      {isReferral && (
  <div className="w-full lg:px-12 flex flex-col">
    <div className="flex flex-col w-full justify-center md:justify-start items-start mt-8 md:mt-12">
      <div className="text-sm md:text-[20px]">
        Other Recommended Certifications For
        <span className="text-[#00C1FF] font-semibold"> Your Profile</span>:
      </div>
     <div className="w-full md:flex md:flex-col overflow-x-hidden md:w-full md:gap-4">
      <div
        className="text-xs md:text-sm mt-3  overflow-x-auto md:mt-5 w-full flex flex-col md:w-full md:flex-row gap-2   cursor-grab"
        onMouseDown={(e) => {
          const target = e.currentTarget;
          let startX = e.pageX;
          let scrollLeft = target.scrollLeft;

          const onMouseMove = (moveEvent) => {
            const x = moveEvent.pageX - startX;
            target.scrollLeft = scrollLeft - x;
          };

          const onMouseUp = () => {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
          };

          document.addEventListener("mousemove", onMouseMove);
          document.addEventListener("mouseup", onMouseUp);
        }}
      >
        <div className="flex gap-2">
          {recommendedCourses?.slice(0, recommendedCourses?.length / 2)?.map((item, index) => (
            <div
              key={index}
              className={`px-3 ${index === clickedButton1 ? "bg-bg-13" : "bg-bg-13/10"}   md:px-6 py-2 gap-1 flex justify-center items-center w-auto rounded-3xl cursor-pointer`}
              onClick={() => {
                Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE_PIL_CLICKED);
                setClickedButton1(index); 
              recommendedSkillHandler(item);
            }}
            >
              <p className="font-formal text-sm md:text-base text-[#70AEFF] whitespace-nowrap">{item}</p>
              <FontAwesomeIcon icon={faArrowRight} className="text-[#70AEFF]" />
            </div>
          ))}
        </div>
        <div className="flex gap-2  ">
          {recommendedCourses?.slice(recommendedCourses?.length / 2, recommendedCourses?.length)?.map((item, index) => (
            <div
              key={index}
              className={`${index === clickedButton2 ? "bg-bg-13" : "bg-bg-13/10"}  px-3  md:px-6 py-2 gap-1 flex justify-center items-center w-auto rounded-3xl cursor-pointer`}
              onClick={() => {
                Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE_PIL_CLICKED);
                setClickedButton2(index); 
              recommendedSkillHandler(item);
            }}
            >
              <span className="font-formal text-sm md:text-base text-[#70AEFF] whitespace-nowrap ">{item}</span>
              <FontAwesomeIcon icon={faArrowRight} className="text-[#70AEFF]" />
              </div>
          ))}
        </div>
      </div>
      <button
      className="text-[#7FC241] w-full text-sm md:text-base mt-2 md:mt-0 self-center text-center underline underline-offset-2"
      onClick={(e)=> {
        Mixpanel.track(constants.Mixpanel.REFERRAL_PAGE_EXPLORE_BUTTON);
        navigate('/1/course-page');

      }}
    >
      Explore More Topics
    </button>
    </div>
    </div>
    <div className="flex flex-col items-start justify-center w-full mt-8 md:mt-12">
      <div className="text-lg md:text-[28px]">
        How It
        <span className="text-[#00C1FF] text-xl md:text-[32px] font-bold"> Works?</span>
      </div>
      <div className="mt-4 md:mt-6 w-full flex gap-2 justify-between items-center">
        <div className="flex flex-col justify-center items-center text-center w-1/3 md:w-auto md:whitespace-nowrap">
          <img src="https://assets.learntube.ai/files/certified%20app/Quiz.svg" alt='' width={width <= 568 ? 24 : 40 } height={width <= 568 ? 24 : 40} />
          <div className="text-xs md:text-[16px] mt-4 text-white/50 w-4/5">Pass A Quick Quiz</div>
        </div>

        <FontAwesomeIcon icon={faArrowRight} size={width <= 568 ? "lg" : "xl"} className="text-white/50" />

        <div className="flex flex-col justify-center items-center text-center w-1/3 md:w-auto md:whitespace-nowrap">
          <img src="https://assets.learntube.ai/files/certified%20app/Certificate.svg" width={width <= 568 ? 24 : 40 } alt='' height={width <= 568 ? 24 : 40} />
          <div className="text-xs md:text-[16px] mt-4 text-white/50 w-4/5">Unlock Instant Certificate</div>
        </div>

        <FontAwesomeIcon icon={faArrowRight} size={width <= 568 ? "lg" : "xl"} className="text-white/50" />

        <div className="flex flex-col justify-center items-center text-center w-1/3 md:w-auto md:whitespace-nowrap">
          <img src="https://assets.learntube.ai/files/certified%20app/LinkedIn.svg" width={width <= 568 ? 24 : 40 } alt='' height={width <= 568 ? 24 : 40} />
          <div className="text-xs md:text-[16px] mt-4 text-white/50 w-full">Share & Get Noticed By Employers</div>
        </div>
      </div>

      <div
      className="mt-8 md:mt-8 text-xs md:text-[20px] md:w-full text-white italic p-4 rounded-xl border-[#70AEFF]/10 border-2"
      style={{
        background: "linear-gradient(90deg, rgba(61, 134, 255, 0.15) 0%, rgba(14, 78, 184, 0.15) 100%)",
      }}
    >
      📈 {referralData?.INDUSTRY} professionals certified with us earn <span className="text-[#00C1FF]">25%</span> more than the industry
      average.
    </div>
    </div>

  
    <div className="mt-32"></div>
  </div>
)}

    </div>
  );
};

export default LandingPage;
